import React, { createContext, useContext } from 'react';
const HarmonyThemeContext = /*#__PURE__*/createContext(false);
export const useIsHarmonyTheme = () => useContext(HarmonyThemeContext);
export const HarmonyThemeProvider = _ref => {
  let enabled = _ref.enabled,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(HarmonyThemeContext.Provider, {
    value: enabled
  }, children);
};
//# sourceMappingURL=HarmonyTheme.js.map